import { useCallback, useState } from 'react';

export const useRedirect = () => {
  const [showRedirect, setShowRedirect] = useState(false);
  const [redirectTo, setRedirectTo] = useState('');

  const redirect = useCallback((url: string) => {
    setRedirectTo(url);
    setShowRedirect(true);
  }, []);

  return { showRedirect, redirectTo, redirect };
};
